import categoryActionTypes from '@nykaa/nes-listing-shared/category/store/actionTypes';
import interactionData from '@nykaa/nes-listing-shared/constants/interactionData';
import { Action } from 'shared/store/types';
import actionTypes from './actionTypes';
import { CategoryListState } from './types';
import { setFilterApiHitCount } from 'helpers/utils/filterApiHitCount';

const defaultState: CategoryListState = {
  errorFetchingPage: false,
  loading: false,
  isFetchingError: false,
  isNotFound: false,
  pageNumber: 1,
  activeFilters: {},
  isFilterChanged: false,
  stopFurtherCall: false,
  isPageChanged: false,
  serverError: false,
  isProductListLoaded: false,
  changeFrom: '',
  widgets: [],
  guides: [],
  isClearAll: false,
  inlineFilters: {},
  remaining_inventories_ids: [],
  queryParamsObject: {},
  fetchedCategoyId: '',
  interactionData,
  isBestPriceLoading: true,
  bestPriceGradient: [],
  bestPriceColor: '',
  bestOfferColor: '',
};

const categoryListing = (
  state = defaultState,
  action: Action
): CategoryListState => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.FETCH_CATEGORY_DATA_PROGRESS:
      return {
        ...state,
        loadingFilterChange: state.isFilterChanged,
        loading: true,
        isNotFound: false,
        isFetchingError: false,
        isFilterChanged: false,
        isPageChanged: false,
        isProductListLoaded: false,
      };

    case actionTypes.FETCH_CATEGORY_DATA_FAILED: {
      const { activeFilters } = state;
      const { page_no = 1 } = activeFilters;
      const pageNo = page_no - 1 || 1;
      const isServer = __SERVER__;
      return {
        ...state,
        activeFilters: {
          ...activeFilters,
          page_no: pageNo,
        },
        loading: false,
        loadingFilterChange: false,
        isNotFound: false,
        isFetchingError: true,
        serverError: isServer,
        isProductListLoaded: false,
      };
    }
    case actionTypes.FETCH_CATEGORY_DATA_SUCCESS: {
      const { listingData, pageNumber, concat, changeFrom, categoryId } =
        payload || {};
      if (!listingData) {
        return { ...defaultState, isFetchingError: true };
      }
      const { listingData: listingDataFromSate, activeFilters } = state;
      const productsFromState = (concat && listingDataFromSate?.products) || [];
      return {
        ...state,
        isProductListLoaded: true,
        loading: false,
        loadingFilterChange: false,
        errorFetchingPage: false,
        activeFilters: {
          ...activeFilters,
          page_no: pageNumber,
          sort: listingData.sort,
        },
        listingData: {
          ...listingData,
          products: [...productsFromState, ...listingData.products],
        },
        changeFrom,
        isClearAll: false,
        stopFurtherCall:
          listingData.stopFurtherCall || listingData.products?.length < 20,
        fetchedCategoyId: categoryId,
      };
    }

    case actionTypes.FETCH_CATEGORY_PAGE_DATA_FAILED: {
      return {
        ...state,
        errorFetchingPage: true,
      };
    }

    case actionTypes.FILTER_CHANGE: {
      setFilterApiHitCount();
      const { activeFilters: activeFiltersSate } = state;
      return {
        ...state,
        activeFilters: {
          ...payload.newFilter,
          page_no: 1,
          sort: activeFiltersSate.sort,
        },
        isClearAll: payload.isClearAll,
        isFilterChanged: true,
      };
    }

    case actionTypes.CHANGE_FILTER_API_STATUS: {
      return {
        ...state,
        listingData: {
          ...state.listingData,
          isApiFailed: payload,
        },
      };
    }

    case actionTypes.SET_ACTIVE_FILTERS: {
      const { activeFilters: activeFiltersSate } = state;
      return {
        ...state,
        activeFilters: {
          ...activeFiltersSate,
          ...payload,
        },
        isFilterChanged: false,
      };
    }
    case actionTypes.CLEAR_PRODUCTS_LIST: {
      const { listingData: listingDataFromSate } = state;
      return {
        ...state,
        listingData: {
          ...listingDataFromSate,
          products: [],
        },
      };
    }
    case actionTypes.SORT_CHANGE: {
      const { activeFilters: activeFiltersSate } = state;
      return {
        ...state,
        activeFilters: {
          ...activeFiltersSate,
          page_no: 1,
          sort: payload,
        },
        isFilterChanged: true,
      };
    }
    case actionTypes.SET_ACTIVE_SORT: {
      return {
        ...state,
        activeSort: payload,
        // isFilterChanged: false,
      };
    }

    case actionTypes.PAGE_CHANGE: {
      const { activeFilters: activeFiltersSate } = state;
      return {
        ...state,
        activeFilters: {
          ...activeFiltersSate,
          page_no: payload,
        },
        isPageChanged: true,
      };
    }

    case actionTypes.INCREASE_PAGE: {
      const { activeFilters: activeFiltersSate } = state;
      return {
        ...state,
        activeFilters: {
          ...activeFiltersSate,
          page_no: (activeFiltersSate.page_no || 0) + 1,
        },
        isPageChanged: true,
      };
    }
    case actionTypes.CLICK_INTERACTION:
      return {
        ...state,
        interactionData: payload,
      };
    case actionTypes.FETCH_WIDGETS: {
      const { widgets, remaining_inventories_ids, queryParamsObject } = payload;
      return {
        ...state,
        widgets,
        remaining_inventories_ids,
        queryParamsObject,
      };
    }

    case actionTypes.RESET_WIDGETS: {
      return {
        ...state,
        widgets: [],
      };
    }

    case actionTypes.TOGGLE_CHANGE_FROM: {
      return {
        ...state,
        changeFrom: '',
      };
    }

    case actionTypes.IS_FILTER_OPEN:
      return {
        ...state,
        isFilterOpen: payload.isFilterOpen,
        activeFilterType: payload.activeFilterType,
      };
    case actionTypes.SET_BREADCRUMB:
      return {
        ...state,
        breadcrumbs: payload,
      };

    case categoryActionTypes.FETCH_INLINE_WIDGET_SUCCESS:
      return {
        ...state,
        inlineWidgets: payload.widgets,
      };

    case categoryActionTypes.FETCH_BEST_PRICE_PROGRESS:
      return {
        ...state,
        isBestPriceLoading: true,
      };

    case categoryActionTypes.FETCH_BEST_PRICE_FAILED: {
      const { listingData } = state;
      const updatedListingProducts = listingData?.products?.map((product) => ({
        ...product,
        isBestPriceLoaded: true,
      }));
      return {
        ...state,
        isBestPriceLoading: false,
        listingData: {
          ...listingData,
          products: updatedListingProducts || [],
        },
      };
    }

    case categoryActionTypes.FETCH_BEST_PRICE_SUCCESS: {
      const { listingData } = state;
      const { bestOffers, gradientColor, textColor, offerTextColor } =
        payload || {};
      const updatedListingProducts = listingData?.products?.map((product) => {
        const { id } = product;
        return {
          ...product,
          isBestPriceLoaded: true,
          ...bestOffers[id],
        };
      });
      return {
        ...state,
        isBestPriceLoading: false,
        bestPriceGradient: gradientColor,
        bestPriceColor: textColor,
        bestOfferColor: offerTextColor,
        listingData: {
          ...listingData,
          products: updatedListingProducts || [],
        },
      };
    }

    default:
      return state;
  }
};

export default categoryListing;
